import React from "react";
import User from "../models/User";
import { ILoginService, LoginService } from "../services/LoginService";
import { INavService } from "../services/NavService";
import { NullTranslator, Translator } from "../services/TranslationService";


export const TopNavContext = React.createContext({
    currentUser: undefined as (User | undefined),
    loginService: new LoginService(u => true) as ILoginService,
    translator: NullTranslator as Translator,
    navService: undefined as (INavService | undefined),
    logoUrl: undefined as (string | undefined),
});
